import type { Severity } from '@dxp/schema';
import Badge, { type BadgeTone } from './Badge.js';

/**
 * §12.1 / §13.2 — Bulgu ciddiyeti. Tek yerde Türkçeleştirilir ve renklenir;
 * §13.1'deki "critical insight bandı" da aynı sözlüğü kullanır.
 * Rozet dili Badge'den gelir — ayrı bir görsel kural yoktur.
 */

export const SEVERITY_LABELS: Record<Severity, string> = {
  critical: 'Kritik',
  high: 'Yüksek',
  medium: 'Orta',
  low: 'Düşük',
};

/** Referans paneldeki ciddiyet renkleri: yüksek = marka turuncusu. */
const SEVERITY_TONES: Record<Severity, BadgeTone> = {
  critical: 'danger',
  high: 'accent',
  medium: 'warning',
  low: 'neutral',
};

export interface SeverityPillProps {
  severity: Severity;
  size?: 'sm' | 'md';
  className?: string;
}

export default function SeverityPill({ severity, size = 'md', className }: SeverityPillProps) {
  return (
    <Badge
      dot
      tone={SEVERITY_TONES[severity]}
      size={size}
      className={className}
      title={`Ciddiyet: ${SEVERITY_LABELS[severity]}`}
    >
      {SEVERITY_LABELS[severity]}
    </Badge>
  );
}
